<template>
  <div>
    <br>
      <ul v-if="lists[index].type =='ul'">
        <li v-for="element in lists[index].elements"> 
          {{element[language]}}
        </li>
      </ul>
      <ol v-if="lists[index].type =='ol'">
        <li v-for="element in lists[index].elements"> 
          {{element[language]}}
        </li>
      </ol>
    <br>
  </div>
</template>

<script>
import axios from 'axios'
import parse from 'csv-parse'

export default {
  name: 'Lists',
  props: ['lists', 'index', 'language'],
  components: {}
}
</script>
<style lang="scss" scoped>
@import "../assets/styles/variables.scss";

.light-gray-1 {
  background-color: #d9d9d9;
}


</style>
